import { render } from "./payIndex.vue?vue&type=template&id=454a36b5&scoped=true"
import script from "./payIndex.vue?vue&type=script&lang=js"
export * from "./payIndex.vue?vue&type=script&lang=js"

import "./payIndex.vue?vue&type=style&index=0&id=454a36b5&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-454a36b5"]])

export default __exports__